export default "__VITE_ASSET__DL7Y$Z5h__"